<template>
  <div class="col-12 col-md-6 col-lg-4  mb-4 mb-lg-0">
    <div class="card h-100">
      <div class="card-body">
        <h2 class="heading-card mb-3">Library Hours</h2>
        <section v-for="(elem, idx) in calendar" v-bind:key="idx">
          <div class="row">
            <div class="col-sm-7">
              <h3><a :href="elem.url">{{ elem.name }}</a></h3>
            </div>
            <div class="col-sm-5">
              <p v-html="elem.rendered"></p>
            </div>
          </div>
        </section>
        <div class="text-center pt-3 text-md-start">
          <a :href="moreHoursURL" class="btn d-inline-block me-1 btn-outline-secondary hvr-icon-forward scroll-anchor">{{ moreHoursTitle }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      calendar: [],
      moreHoursTitle: 'More Library Hours',
      moreHoursURL: 'https://csub.libguides.com/c.php?g=576222&p=4167641'
    }
  },

  async created () {
    const { data: jsonData } = await axios.get('https://csub.libcal.com/api_hours_today.php?iid=4519&lid=8923&format=json&systemTime=0')
    this.calendar = jsonData.locations
  }
}
</script>

<style scoped>
  .card-body section {
    display: block;
    border-top: 1px solid #ccc;
    padding-top: 20px;
  }
  .card-body h3 {
    font-family: 'Oswald';
    font-size: 18px;
  }
</style>
